// @flow

/**
 * Data Display Error Boundary
 * Catches render errors in display components and shows a fallback
 */

import React from 'react';
import styled from 'styled-components';

const ErrorFallback = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 80px;
  margin: 0.5rem 0;
  padding: 1rem;
  border: 1px solid rgba(219, 55, 55, 0.3);
  border-radius: 6px;
  background: rgba(219, 55, 55, 0.05);
  color: rgba(219, 55, 55, 0.8);
  font-size: 0.85rem;
`;

type Props = {
  children: React$Node,
  displayId?: string,
};

type State = {
  hasError: boolean,
};

class DataDisplayErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: { componentStack: string }) {
    console.error(
      `DataDisplay render error [${this.props.displayId || 'unknown'}]:`,
      error,
      info,
    );
  }

  render(): React$Node {
    if (this.state.hasError) {
      return (
        <ErrorFallback>
          Unable to display this visualisation
        </ErrorFallback>
      );
    }
    return this.props.children;
  }
}

export default DataDisplayErrorBoundary;
